export default "__VITE_ASSET__483a1355__"